import { modalDisplayed } from 'actions/modalDisplayed';

import errorMessages from 'consts/errorMessageConsts';
import responseTypes from 'consts/responseConsts';

export function handleNullResponse() {
  return dispatch => {
    dispatch(modalDisplayed(errorMessages.GENERAL_ERROR_MESSAGE));
    return responseTypes.NO_RESPONSE;
  };
}
